import { render, staticRenderFns } from "./cadgarantiasfor.vue?vue&type=template&id=8c5350cc&"
import script from "./cadgarantiasfor.vue?vue&type=script&lang=js&"
export * from "./cadgarantiasfor.vue?vue&type=script&lang=js&"
import style0 from "./cadgarantiasfor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports